// FAB Diagnostic Questions Data - 15 Questions (5 per section)
// Scoring: A=1, B=2, C=3, D=4 points

export const FRAMEWORK_QUESTIONS = [
  {
    id: "f1",
    text: "Do you have a written investment plan (IPS) covering goals, allocation and review rules?",
    description: "Documenting your investment policy statement",
    options: [
      { value: 1, label: "A", text: "No written plan" },
      { value: 2, label: "B", text: "Informal notes / mental framework only" },
      { value: 3, label: "C", text: "Written plan, partially detailed" },
      { value: 4, label: "D", text: "Formal written IPS, reviewed periodically" }
    ]
  },
  {
    id: "f2",
    text: "Are your investments mapped to clear time horizons? (short/medium/long term)",
    description: "Time-based investment mapping",
    options: [
      { value: 1, label: "A", text: "No time-based mapping" },
      { value: 2, label: "B", text: "Broad idea, not documented" },
      { value: 3, label: "C", text: "Most investments mapped" },
      { value: 4, label: "D", text: "All investments clearly mapped by horizon" }
    ]
  },
  {
    id: "f3",
    text: "Is there a pre-defined portfolio review cadence?",
    description: "Regular review schedule",
    options: [
      { value: 1, label: "A", text: "Reviews are ad-hoc" },
      { value: 2, label: "B", text: "Reviews happen irregularly" },
      { value: 3, label: "C", text: "Annual or semi-annual reviews" },
      { value: 4, label: "D", text: "Fixed cadence with documented agenda" }
    ]
  },
  {
    id: "f4",
    text: "Are rebalancing rules defined before market movements?",
    description: "Pre-defined rebalancing framework",
    options: [
      { value: 1, label: "A", text: "No rebalancing framework" },
      { value: 2, label: "B", text: "Rebalancing done reactively" },
      { value: 3, label: "C", text: "Time-based or band-based triggers" },
      { value: 4, label: "D", text: "Clearly documented rules followed consistently" }
    ]
  },
  {
    id: "f5",
    text: "How do you track portfolio progress?",
    description: "Progress tracking methodology",
    options: [
      { value: 1, label: "A", text: "Track only absolute returns" },
      { value: 2, label: "B", text: "Compare returns loosely with benchmarks" },
      { value: 3, label: "C", text: "Track against goals periodically" },
      { value: 4, label: "D", text: "Goal-level tracking with periodic reporting" }
    ]
  }
];

export const ALLOCATION_QUESTIONS = [
  {
    id: "a1",
    text: "Does your equity allocation stay within a defined tolerance range?",
    description: "Equity allocation discipline",
    options: [
      { value: 1, label: "A", text: "No defined target" },
      { value: 2, label: "B", text: "Often deviates materially" },
      { value: 3, label: "C", text: "Usually within ±10%" },
      { value: 4, label: "D", text: "Consistently within ±5%" }
    ]
  },
  {
    id: "a2",
    text: "What proportion of your total investible assets is invested outside India?",
    description: "Global diversification",
    options: [
      { value: 1, label: "A", text: "0% (no global exposure or defined plan)" },
      { value: 2, label: "B", text: "<5%" },
      { value: 3, label: "C", text: "5–15%" },
      { value: 4, label: "D", text: ">15% (planned global allocation)" }
    ]
  },
  {
    id: "a3",
    text: "How dependent is your portfolio on a single scheme or stock?",
    description: "Concentration risk",
    options: [
      { value: 1, label: "A", text: ">35% of investible assets" },
      { value: 2, label: "B", text: "25–35%" },
      { value: 3, label: "C", text: "15–25%" },
      { value: 4, label: "D", text: "<15%" }
    ]
  },
  {
    id: "a4",
    text: "What role does debt play in your portfolio?",
    description: "Debt allocation strategy",
    options: [
      { value: 1, label: "A", text: "No clear role" },
      { value: 2, label: "B", text: "Used to reduce portfolio risk" },
      { value: 3, label: "C", text: "Liquidity / stability role" },
      { value: 4, label: "D", text: "Explicit role with sizing rules" }
    ]
  },
  {
    id: "a5",
    text: "Have you studied the overlap between your Mutual Fund schemes?",
    description: "Portfolio overlap awareness",
    options: [
      { value: 1, label: "A", text: "Unsure / not evaluated" },
      { value: 2, label: "B", text: "Suspect overlap but not tracked" },
      { value: 3, label: "C", text: "Overlap reviewed periodically" },
      { value: 4, label: "D", text: "Overlap actively tracked & controlled" }
    ]
  }
];

export const BEHAVIOUR_QUESTIONS = [
  {
    id: "b1",
    text: "What usually triggers changes in your portfolio allocation?",
    description: "Decision-making triggers",
    options: [
      { value: 1, label: "A", text: "Market news, price movements, or gut feel" },
      { value: 2, label: "B", text: "After markets move sharply up or down" },
      { value: 3, label: "C", text: "During periodic reviews" },
      { value: 4, label: "D", text: "Only when pre-decided limits are breached" }
    ]
  },
  {
    id: "b2",
    text: "What happened to SIPs during market declines?",
    description: "SIP continuity during corrections",
    options: [
      { value: 1, label: "A", text: "Stopped SIPs" },
      { value: 2, label: "B", text: "Reduced SIPs" },
      { value: 3, label: "C", text: "Continued unchanged" },
      { value: 4, label: "D", text: "Increased or maintained as planned" }
    ]
  },
  {
    id: "b3",
    text: "Have recent high-performing assets influenced new allocations?",
    description: "Performance chasing behaviour",
    options: [
      { value: 1, label: "A", text: "Frequently" },
      { value: 2, label: "B", text: "Occasionally" },
      { value: 3, label: "C", text: "Rarely" },
      { value: 4, label: "D", text: "Only if aligned to plan" }
    ]
  },
  {
    id: "b4",
    text: "During volatile periods, how often were actions taken outside the documented plan?",
    description: "Plan adherence during volatility",
    options: [
      { value: 1, label: "A", text: "Frequently" },
      { value: 2, label: "B", text: "Occasionally" },
      { value: 3, label: "C", text: "Rarely" },
      { value: 4, label: "D", text: "Never" }
    ]
  },
  {
    id: "b5",
    text: "During market declines, how confident are you staying invested?",
    description: "Investment conviction during downturns",
    options: [
      { value: 1, label: "A", text: "Usually exit or reduce" },
      { value: 2, label: "B", text: "Often unsure" },
      { value: 3, label: "C", text: "Stay invested with discomfort" },
      { value: 4, label: "D", text: "Stay invested as planned" }
    ]
  }
];

export const QUARTILE_INFO = {
  Foundational: {
    label: "Foundational",
    sublabel: "3rd Quartile",
    color: "#DC2626",
    bgColor: "rgba(239, 68, 68, 0.1)",
    description: "Your investment approach shows potential for significant improvement. Building a structured framework, clear allocation strategy, and disciplined behavioral patterns will help you achieve more consistent results.",
    recommendations: [
      "Document your financial goals and investment plan in writing",
      "Review your current asset allocation with a qualified advisor",
      "Establish clear rules for investment decisions to reduce emotional bias",
      "Schedule a FAB Diagnostic Call to discuss personalized strategies"
    ]
  },
  Transitional: {
    label: "Transitional",
    sublabel: "2nd Quartile",
    color: "#D97706",
    bgColor: "rgba(245, 158, 11, 0.1)",
    description: "You have established good foundations but there are opportunities to strengthen your investment discipline. Focus on documenting your process and maintaining consistency during market volatility.",
    recommendations: [
      "Strengthen documentation of your investment rationale",
      "Implement a systematic rebalancing schedule",
      "Develop a written protocol for market volatility periods",
      "Consider a FAB Diagnostic Call to optimize your approach"
    ]
  },
  Systematic: {
    label: "Systematic",
    sublabel: "1st Quartile",
    color: "#059669",
    bgColor: "rgba(76, 184, 96, 0.1)",
    description: "Your investment approach demonstrates strong discipline across framework, allocation, and behaviour. Continue refining your process and consider working with an advisor to optimize your strategy.",
    recommendations: [
      "Continue maintaining your disciplined investment process",
      "Review and refine your framework annually",
      "Consider advanced strategies for portfolio optimization",
      "Schedule a FAB Diagnostic Call to explore advanced advisory services"
    ]
  }
};
